import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServicePatternsPageStore } from './services-patterns-page.store';
import { dateField, nameColumn } from '../../../../shared/components/kit/table/table.fields';
import { router } from '../../../../shared/shared.global-service';
import { ActivatedRoute } from '@angular/router';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { ServicePatternObject } from '@libs/types/src/services/object-type/service/service-pattern.object';
import { ServicePatternsPageStore2 } from './services-patterns-page.store2';
import { selectService } from '../../../store/service/service.selectors';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-service-patterns-page',
    templateUrl: './service-patterns-page.component.html',
    styleUrl: './service-patterns-page.component.scss',
    providers: [ServicePatternsPageStore, ServicePatternsPageStore2],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardTableComponent,
        AsyncPipe,
        TranslatePipe,
        PrimeTemplate,
    ],
})
export class ServicePatternsPageComponent extends SubscriptionComponent {

    public readonly store2 = inject(ServicePatternsPageStore2);
    protected readonly store = inject(ServicePatternsPageStore);
    private readonly route = inject(ActivatedRoute);
    private readonly confirm = inject(ConfirmBuilder);


    protected serviceId = 0;
    protected service = this.store!.globalStore!.selectSignal(selectService);

    protected columns = [
        {
            name: 'usage',
            type: TableColumnType.String,
        },
        nameColumn,
        dateField('validFrom'),
        dateField('validTo'),
        {
            name: 'note',
            type: TableColumnType.String,
        },
    ];

    constructor() {
        super();
        this.store.refreshGrid('getServicePatterns', 'deleteServicePattern');
        this.store.onRouteChange('getServicePatterns', { serviceId: 'serviceId' }, { asFilter: true });

        this.store.registerSuccessMessage('deleteServicePattern', 'common.deleted');
        this.subs.push(
            this.store.routeParam.serviceId.subscribe((serviceId) => {
                this.serviceId = Number(serviceId || 0);
            }),
        );
    }

    protected async goTo(route: 'structures' | 'documents', item?: ServicePatternObject): Promise<void> {
        await router.navigate([`${route}/${item ? item.id : 'create'}`], { relativeTo: this.route });
    }

    protected deletePattern(item: any): void {
        this.confirm.confirm(
            'common.delete',
            null,
            () => this.store.api.deleteServicePattern({ id: item.item.id }),
            null,
            'pi-trash',
            item.event.target,
        );
    }

    protected readonly ServiceTypeEnum = ServiceTypeEnum;
}
